import { VFC } from 'react';

import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import Permissioned from 'dashboard/components/Permissioned';
import { formatAddress, formatDate } from 'dashboard/lib/utils/formatters';
import { ReportSentilinkApplicationRisk } from 'dashboard/models/report/integration/sentilink-application-risk';
import { Permission } from 'lib/permissions';

interface SentilinkApplicationRiskProps {
  report: ReportSentilinkApplicationRisk;
  isRedacted: boolean;
}

const SentilinkApplicationRisk: VFC<SentilinkApplicationRiskProps> = ({
  report: {
    attributes: {
      query: {
        'user-id': userId,
        'name-first': nameFirst,
        'name-last': nameLast,
        birthdate: birthdate,
        'email-address': emailAddress,
        'phone-number': phoneNumber,
        'social-security-number': socialSecurityNumber,
        'address-street-1': addressStreet1,
        'address-street-2': addressStreet2,
        'address-city': addressCity,
        'address-subdivision': addressSubdivision,
        'address-postal-code': addressPostalCode,
        'address-country-code': addressCountryCode,
        'ip-address': ipAddress,
      },
    },
  },
  isRedacted,
}: SentilinkApplicationRiskProps) => {
  const truncatedSSN = socialSecurityNumber?.substring(socialSecurityNumber?.length - 4);
  return (
    <AttributeGrid>
      <AttributeItem
        title='First Name'
        value={nameFirst}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-sentilink-application-risk__name-first'
      />
      <AttributeItem
        title='Last Name'
        value={nameLast}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-sentilink-application-risk__name-last'
      />
      <AttributeItem
        title='Birthdate'
        value={formatDate(birthdate)}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-sentilink-application-risk__birthdate'
      />
      <AttributeItem
        title='User ID'
        value={userId}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-sentilink-application-risk__user-id'
      />
      <AttributeItem
        title='Phone Number'
        value={phoneNumber}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-sentilink-application-risk__phone-number'
      />
      <AttributeItem
        title='Email Address'
        value={emailAddress}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-sentilink-application-risk__email-address'
      />
      <AttributeItem
        title='Address'
        value={formatAddress({
          addressStreet1,
          addressStreet2,
          addressCity,
          addressSubdivision,
          addressPostalCode,
          countryCode: addressCountryCode,
        })}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-sentilink-application-risk__address'
      />
      <AttributeItem
        title='Country'
        value={addressCountryCode}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-sentilink-application-risk__country-code'
      />
      <AttributeItem
        title='IP Address'
        value={ipAddress}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-sentilink-application-risk__ip-address'
      />
      <Permissioned
        permission={Permission.ReportSsnView}
        fallback={
          <AttributeItem
            title='SSN'
            value={truncatedSSN}
            placeholder='SSN'
            isRedacted={isRedacted}
            dataTest='report-sentilink-application-risk__ssn'
          />
        }
      >
        <AttributeItem
          title='SSN'
          value={socialSecurityNumber}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-sentilink-application-risk__ssn'
        />
      </Permissioned>
    </AttributeGrid>
  );
};

export default SentilinkApplicationRisk;
